import { useEffect } from "react";

function PropertyCategory({ setSelectedCategory, goBack }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg,#000,#1a1a1a,#ffd600)",
        padding: "20px"
      }}
    >
      {/* BACK BUTTON */}
      <button
        onClick={goBack}
        style={{
          padding: "12px 20px",
          border: "none",
          borderRadius: "10px",
          fontWeight: "bold",
          cursor: "pointer",
          marginBottom: "20px"
        }}
      >
        ⬅ Back
      </button>

      {/* MAIN CARD */}
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          background: "white",
          borderRadius: "25px",
          padding: "25px",
          textAlign: "center",
          boxSizing: "border-box"
        }}
      >
        <h1 style={{ marginBottom: "10px" }}>
          🏘️ Property Category
        </h1>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Select the type of property you are searching for.
        </p>

        {/* GRID */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "20px"
          }}
        >
          {/* RESIDENTIAL */}
          <div
            style={{
              background: "#f5f5f5",
              padding: "25px",
              borderRadius: "20px",
              boxSizing: "border-box"
            }}
          >
            <h1>🏠</h1>
            <h2>Residential</h2>
            <p>Houses, apartments, bedsitters and bungalows.</p>

            <button
              onClick={() => setSelectedCategory("Residential")}
              style={{
                width: "100%",
                maxWidth: "260px",
                padding: "12px",
                marginTop: "15px",
                background: "#ffd600",
                border: "none",
                borderRadius: "10px",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              Residential
            </button>
          </div>

          {/* COMMERCIAL */}
          <div
            style={{
              background: "#f5f5f5",
              padding: "25px",
              borderRadius: "20px",
              boxSizing: "border-box"
            }}
          >
            <h1>🏢</h1>
            <h2>Commercial</h2>
            <p>Office spaces, shops, warehouses and business premises.</p>

            <button
              onClick={() => setSelectedCategory("Commercial")}
              style={{
                width: "100%",
                maxWidth: "260px",
                padding: "12px",
                marginTop: "15px",
                background: "#ffd600",
                border: "none",
                borderRadius: "10px",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              Commercial
            </button>
          </div>
        </div>
      </div>

      {/* MOBILE FIX CSS */}
      <style>{`
        @media (max-width: 600px) {
          div[style*="maxWidth: 900px"] {
            padding: 18px !important;
          }

          button {
            max-width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
}

export default PropertyCategory;